module.exports = __webpack_public_path__ + "static/img/QRcode.5d9eb2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/QRcode.png
// module id = 37ZR
// module chunks = 11